import React, { forwardRef, memo } from 'react';
import SVGIcon from './SVGIcon';

function createIcon(name, element, defaultProps) {
  function Icon(props, forwardedRef) {
    return (
      <SVGIcon ref={forwardedRef} {...defaultProps} {...props}>
        {element}
      </SVGIcon>
    );
  }

  Icon.displayName = `${name}Icon`;

  return memo(forwardRef(Icon));
}

export default createIcon;
